/* template */
<template><div class="mpx-root-view"><div class="container" v-if="(isCxvip)"><div class="info"><mpx-image :src="(vipicon)" class="vip-icon"></mpx-image><div>12306畅行会员</div></div><div class="tip"><div>已开通，享候补抢票</div></div></div><div class="common-container" v-else><div class="common-container-info"><div class="title">开通12306畅行会员</div><div class="sub-title">开通会员，享受双渠道抢票权益</div><mpx-view @tap="toOpenCxvip" class="open-btn">立即开通</mpx-view></div><mpx-image :src="(unvipicon)" class="unvip-icon"></mpx-image></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m6f4f6739"}'>
.container
  border-radius 8px
  box-sizing border-box
  height 56px
  background #F8F9FD
  @extend .flex-center
  justify-content space-between
  padding 14px 8px 14px 16px
  margin-top 12px
  font-weight normal
  line-height 1
  letter-spacing 0px
  .info, .tip
    @extend .flex-center
  .info
    font-family PingFangSC-Medium
    font-size 16px
    color #000000
    .vip-icon
      width 28px
      height 28px
      margin-right 8px
  .tip
    font-family PingFangSC-Regular
    font-size 12px
    color #666666
.common-container
  border-radius 8px
  box-sizing border-box
  margin-top 12px
  background #EAF3FF
  height 108px
  display flex
  align-items flex-start
  justify-content space-between
  padding 10px 16px
  &-info
    display flex
    flex-direction column
    align-items flex-start
    justify-content flex-start
    line-height 1
    .title
      font-family PingFangSC-Medium
      font-size 16px
      font-weight normal
      letter-spacing 0px
      color #000000
      margin-top 6px
    .sub-title
      font-family PingFangSC-Regular
      font-size 12px
      font-weight normal
      letter-spacing 0px
      color #3D3D3D
      margin-top 8px
    .open-btn
      width 74px
      height 28px
      @extend .flex-center
      justify-content center
      border-radius 5px
      background-color #338FFF
      color #FFFFFF
      font-family PingFangSC-Medium
      font-size 12px
      font-weight normal
      letter-spacing 0px
      margin-top 12px
  .unvip-icon
    width 90px
    height 90px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6f4f6739"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./cxvip-card.mpx.js?isComponent&outputPath=components%2Fcxvip-card6f4f6739%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./cxvip-card.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fcxvip-card6f4f6739%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6f4f6739"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/cxvip-card6f4f6739/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
